import $ from 'jquery'
import Splide from '@splidejs/splide'

document.addEventListener("DOMContentLoaded", function() {
    const menuIds = ["service_menu_mobile", "service_menu_desktop"];
    menuIds.forEach(function(menuId) {
        let menuElement = document.getElementById(menuId);
        if (menuElement === null) {
            return;
        }

        let serviceposts = document.querySelectorAll('.single-service__content h2');
        let ul = document.createElement('ul');

        serviceposts.forEach(function(post, index) {
            if (!post.classList.contains('single-service__content--title')) {
                let id = 'service_title_' + (index + 1);
                post.id = id;
                let li = document.createElement('li');
                let a = document.createElement('a');
                a.href = '#' + id;
                a.textContent = post.textContent;
                li.appendChild(a);
                ul.appendChild(li);
            }
        });

        menuElement.appendChild(ul);
    });
});

document.addEventListener('DOMContentLoaded', function() {
    let links = document.querySelectorAll('.summary ul li a');
    links.forEach(function(link) {
        link.addEventListener('click', function(event) {
            let href = this.getAttribute('href');
            if (href && href.startsWith('#')) {
                let targetId = href.substring(1);
                let targetElement = document.getElementById(targetId);
                if (targetElement) {
                    let offset = 100;
                    let targetPosition = targetElement.offsetTop - offset;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                    event.preventDefault();
                }
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const sliderElement = document.querySelector('.single-service__slider');
    let singleservice__slider;

    if (sliderElement) {
        function initializeSplide() {
            if (window.innerWidth > 1024) {
                if (!singleservice__slider) {
                    singleservice__slider = new Splide('.single-service__slider', {
                        type: 'loop',
                        perPage: 3.5,
                        perMove: 1,
                        gap: '30px',
                        arrows: false,
                        pagination: false,
                    });
                    singleservice__slider.mount();
                }
            } else {
                if (singleservice__slider) {
                    singleservice__slider.destroy(true);
                    singleservice__slider = null;
                }
            }
        }
        initializeSplide();
        window.addEventListener('resize', initializeSplide);
    }
});
